import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Farhan Sadiq',
    title: "Web Developer",
    desciption: "MERN Stack Developer from Dhaka, Bangladesh. Passionate about technology. I love to explore new technologies, solve new problems and continuously learn new things to make the applications and websites I build more useful and enjoyable for their users.",
    image: 'https://i.ibb.co/L57Ct8t/IMG-20221208-113448-123.jpg',
    resumePdf: resume
}
